import { useDynamicHeatmapContext } from 'modules/campaignAnalytics/context';
import styled from 'styled-components';
import { InfoBanner } from 'ui/banner';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { spacing } from 'ui/theme';

const InfoBannerWrapper = styled.div`
  margin-bottom: ${spacing.plusHalf};
`;

const StyledInfoBanner = styled(InfoBanner)`
  & > * {
    align-self: center;
  }
`;

export const LegacyHeatmapBanner = () => {
  const { hasLegacyAndDynamicClicks, setShowLegacy, showLegacy, hasTrackingErrors } =
    useDynamicHeatmapContext();
  return (
    <>
      {hasLegacyAndDynamicClicks && !hasTrackingErrors && (
        <InfoBannerWrapper data-test="legacy-banner">
          <StyledInfoBanner
            BannerActions={
              <SecondaryButton size={BUTTON_SIZES.SMALL} onClick={() => setShowLegacy(!showLegacy)}>
                Switch to {showLegacy ? 'new view' : 'legacy view'}
              </SecondaryButton>
            }
          >
            This campaign contains data generated before and after the release of heatmaps
            enhancements. To view{' '}
            {showLegacy ? 'new data, switch to new view.' : 'past data, switch to legacy view.'}
          </StyledInfoBanner>
        </InfoBannerWrapper>
      )}
    </>
  );
};
